import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-infobox-card',
  templateUrl: './infobox-card.component.html',
  styleUrls: ['./infobox-card.component.sass']
})
export class InfoboxCardComponent implements OnInit {

  @Input() infobox:any = {};

  constructor(private router:Router) { }

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

}
